import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';
import Post from '../../Post';
import { Link } from 'react-router-dom';

export default function BlogSection({
  data,
  sectionTitle,
  sectionTitleUp,
  sectionTitleDown,
  sectionSubTitle,
}) {
  return (
    <div className="container">
      <SectionHeading
        title={sectionTitle}
        titleUp={sectionTitleUp}
        titleDown={sectionTitleDown}
        subTitle={sectionSubTitle}
        center
      />
      <Spacing md="72" lg="50" />
      <div className="row gy-4">
        {data?.map((item, index) => (
          <div className="col-lg-4" key={index}>
            <Post {...item} data={data} />
          </div>
        ))}
      </div>
     
      <div className='d-flex justify-content-center p-4 mt-5 '>
        <Link to="/products">
  <button 
    style={{
      padding: "1rem", 
      backgroundColor: "#79B41A", 
      border: "none", 
      borderRadius: "0.5rem"
    }} 
    className='text-white'
  >
    Explore Products
  </button>
  </Link>
</div>

    </div>
  );
}
